<template>
  <div>
    <el-form-item class="ai-items" label="词汇列表">
      <div class="ai-item-wrap" v-for="(item, key) in form.list" :key="item.id">
        <ai_word_item :item="item">
          <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
          <el-button icon="el-icon-plus" tabindex="-1" @click="addItem(key)"></el-button>
        </ai_word_item>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import baseList from "./base-list.js";
import ai_word_item from "@/components/lesson/units/ai/ai_word_item.vue";

export default {
  name: "ai_words_form",
  components: {ai_word_item},
  props: {
    form: Object
  },
  data() {
    return {
      type: 2,
    }
  },
  mixins: [baseList],
  watch: {
    form: {
      immediate: true,
      handler(val) {
        if (!val.list) {
          val.list = [];
        }
        if (val.length < 1) {
          this.addItem(0);
        }
      }
    }
  }
}
</script>